/**
 * PreAuth.tsx
 *
 * This file defines the layout for non-authenticated pages.
 * It serves as a wrapper for the components that do not require user authentication.
 */

import { ReactNode } from 'react';

interface PreAuthProps {
  children: ReactNode;
}

const PreAuth = ({ children }: PreAuthProps) => <>{children}</>;

export default PreAuth;
